module.exports = __webpack_public_path__ + "img/IG.34499a3a.png";